var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExploreNav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 11.061a3 3 0 00-1.75-2.727L20.834 2.182a2 2 0 00-1.668 0L5.75 8.334A3 3 0 004 11.061V28.938a3 3 0 001.75 2.727l13.416 6.153a2 2 0 001.668 0l13.417-6.153A3 3 0 0036 28.94V11.06zm-9.42 18.485a1.479 1.479 0 01-2.128 0L20.49 25.49v-.001a1.566 1.566 0 01-.003-2.178 1.479 1.479 0 012.13-.002l1.4 1.431V11.541c0-.855.674-1.541 1.506-1.541.833 0 1.507.686 1.507 1.541V24.74l1.399-1.429v-.001a1.482 1.482 0 012.127-.003c.594.6.591 1.579.002 2.181l-3.976 4.059zM13.42 10.451a1.479 1.479 0 012.128 0l3.963 4.057v.001c.596.603.583 1.58.003 2.178a1.479 1.479 0 01-2.13.002l-1.4-1.431v13.198c0 .855-.674 1.54-1.506 1.54s-1.507-.685-1.507-1.54V15.259l-1.399 1.429v.001a1.482 1.482 0 01-2.127.003 1.562 1.562 0 01-.002-2.181l3.976-4.059z",
    fill: "var(--icon-default)"
  })));
}
export default SvgExploreNav;